import React from 'react';

import { Container } from '../common/Container.jsx';
import Utilities from '../common/Utilities.jsx';

const instances = {};
function withPaging(WrappedComponent, requestConfig) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            let id = `${new Date().getTime()}`;
            if (requestConfig && requestConfig.path) {
                id = `${requestConfig.path}-${id}`
            }
            this.state = {
                data: props.data,
                id,
                q: props.q
            };
            this.defaultLimit = 30;

            this._get = this._get.bind(this);
            this.handleLoadMore = this.handleLoadMore.bind(this);
            this.handleRegisterRequestDataHandler = this.handleRegisterRequestDataHandler.bind(this);
            this.handleRegisterResponseDataPostProcessHandler = this.handleRegisterResponseDataPostProcessHandler.bind(this);
            this.handleRegisterResponseDataPreProcessHandler = this.handleRegisterResponseDataPreProcessHandler.bind(this);
            this.handleReset = this.handleReset.bind(this);
        }

        componentDidMount() {
            instances[this.state.id] = true;
        }
    
        componentWillUnmount() {
            instances[this.state.id] = undefined;
    
            if (this.getRequest) {
                this.getRequest.abort();
                this.getRequest = null;
            }
        }
    
        _get(query, callback) {
            if (!requestConfig || !requestConfig.path || this.state.loading) {
                return;
            }
            const component = this;
            component.setState({
                loading: true
            });
            if (component.getRequest) {
                component.getRequest.abort();
                component.getRequest = null;
            }
            let requestData = component.state.q;
            if (!requestData) {
                requestData = { limit: requestConfig.limit || component.defaultLimit, offset: 0 };
                component.setState({
                    q: requestData
                });
            }
            requestData.dataSub = component.props.queryDataSub;
            requestData.sub = component.props.config.subdomain;
            if (component.requestDataHandler) {
                component.requestDataHandler(requestData);
            }
            Utilities.copyObject(query, requestData);
            
            let route = `/api/${requestConfig.path}`;
            if (component.props.handlerUrl) {
                route = component.props.handlerUrl + route;
            }
            component.getRequest = $.get(
                route,
                requestData,
                function (responseData) {
                    if (!instances[component.state.id]) {
                        return;
                    }
                    if (component.responseDataPreProcessHandler) {
                        component.responseDataPreProcessHandler(responseData);
                    }
                    let _data = component.state.data;
                    if (!_data) {
                        _data = responseData;
                    } else if (_data[requestConfig.resultKey] && responseData[requestConfig.resultKey]) {
                        _data.hasMore = responseData.hasMore;
                        _data[requestConfig.resultKey] = _data[requestConfig.resultKey].concat(responseData[requestConfig.resultKey]);
                    }
                    const q = component.state.q || {};
                    if (_data[requestConfig.resultKey]) {
                        if (requestData.offset == 0 && component.props.onAsyncLoad) {
                            if (!requestConfig || !requestConfig.onCheckFilter || !requestConfig.onCheckFilter(requestData, component.props.context)) {
                                component.props.onAsyncLoad(component.props.blockId, _data[requestConfig.resultKey]);
                            }
                        }
                        q.offset = _data[requestConfig.resultKey].length;
                    }
                    if (component.responseDataPostProcessHandler) {
                        component.responseDataPostProcessHandler(_data);
                    }
                    component.setState({
                        data: _data,
                        q: q
                    }, function () {
                        if (callback) {
                            callback();
                        }
                    });
                }).always(function () {
                    component.getRequest = null;
    
                    if (!instances[component.state.id]) {
                        return;
                    }
                    component.setState({
                        loading: false
                    });
                });
        }

        handleLoadMore(e, callback) {
            if (!this.state.data || this.state.loading || (this.state.data && !this.state.data.hasMore) || this.props.active == false) {
                return;
            }
            this._get(undefined, callback);
        }

        handleRegisterRequestDataHandler(handler) {
            this.requestDataHandler = handler;
        }

        handleRegisterResponseDataPostProcessHandler(handler) {
            this.responseDataPostProcessHandler = handler;
        }    

        handleRegisterResponseDataPreProcessHandler(handler) {
            this.responseDataPreProcessHandler = handler;
        }

        handleReset(limit) {
            const q = this.state.q;
            q.offset = 0;
            this.setState({
                data: undefined,
                q: { limit: limit || this.defaultLimit, offset: 0}
            });
        }
    
        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    data={this.state.data}
                    loading={this.state.loading}
                    q={this.state.q}
                    onLoad={this._get}
                    onLoadMore={this.handleLoadMore}
                    onRegisterRequestDataHandler={this.handleRegisterRequestDataHandler}
                    onRegisterResponseDataPostProcessHandler={this.handleRegisterResponseDataPostProcessHandler}
                    onRegisterResponseDataPreProcessHandler={this.handleRegisterResponseDataPreProcessHandler}
                    onReset={this.handleReset}>
                    {this.props.children}
                </WrappedComponent>
            )
        }
    }
}

function ContentContainer(props) {
    let className;
    if (props.type) {
        className = `cont--${props.type}`;
    }
    if (props.className) {
        if (className) {
            className = `${className} ${props.className}`;
        } else {
            className = props.className
        }
    }
    return (
        <Container className={className} style={props.style}>
            {props.children}
        </Container>
    );
}

export { ContentContainer, withPaging };